import { DomainType } from '../redux/domains/types'
import { Dictionary } from '../utils/types'

import { useApiData } from './useApiData'

export function useDomains(
  domainTypes: DomainType[],
  countryCode?: string,
  skip?: boolean
): { umbracoData?: Dictionary<Dictionary<string>>; refresh: () => void } {
  const { data: umbraco, refresh } = useApiData<Dictionary<Dictionary<string>>>(
    {
      url: '/api/translation/domain',
      method: 'post',
      data: {
        countryCode,
        domainTypes,
        translationType: 'umbraco'
      }
    },
    {
      umbracoCall: true,
      overrideCountryCode: countryCode,
      skip: skip
    }
  )

  return {
    umbracoData: umbraco,
    refresh
  }
}
